module.exports = __webpack_public_path__ + "static/media/focus.f5c1f0c5.svg";